export default {
  Label_Common: {
    Dai_ChuShiHua: 'Waiting init',
    ZhengZai_ChuShiHua: 'Initializing',
    YiChang: 'Abnormal',
    ZhengChang_YingYe: 'Open',
    TingZhi_YingYe: 'Closed',
    ZhenJiu_FanFa: "A' Method",
    ZhenJiu_WeiZhi: "A' Location",
    YaoPing_GongNeng: "D' Function",
    YaoPing_PingPai: "D' Brand",
    YaoPing_BiaoZhun: "D' Standard",
    HuiYuan_LeiBie: 'Member Type',
    ChaKan: 'View',
    QiTa_ZhuMing: 'Other · Note',
    HuaYan_LeiXing: 'LabExam Type',
  },
}
